import { LocDisplayType } from '../models';

export const SYSTEM_ERROR_ROOT = 'System|Error';
export const SYSTEM_ERROR_TYPE: LocDisplayType = 'Error';

export const SYSTEM_ENUM_ROOT = 'System|Enum';
export const SYSTEM_ENUM_TYPE: LocDisplayType = 'System';

export const SYSTEM_FEATURE_ROOT = 'System|Feature';
export const SYSTEM_FEATURE_TYPE: LocDisplayType = 'Content';
